<template>
    <div v-if="loaded">
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="2">
                        <rkm-form-input
                            :validations="validations.ano"
                            label="Ano"
                            number
                            v-model="model.periodo.ano"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            :options="form.meses"
                            :validations="validations.mes"
                            label="Mês"
                            show-default-option
                            v-model="model.periodo.mes"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disableUnidade"
                            :options="form.unidades"
                            @change="loadFrom('unidade')"
                            default-option-text="Todas"
                            label="Unidade"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disableInfraestrutura"
                            :options="form.infraestruturas"
                            @change="loadFrom('infraestrutura')"
                            default-option-text="Todos"
                            label="Local de atendimento"
                            show-default-option
                            text-field="nome"
                            v-model="model.infraestruturaId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disableOcupacao"
                            :options="form.ocupacoes"
                            @change="loadFrom('ocupacao')"
                            default-option-text="Todas"
                            label="CBO"
                            show-default-option
                            text-field="descricao"
                            v-model="model.ocupacaoId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disableEspecialidade"
                            :options="form.especialidades"
                            default-option-text="Todas"
                            label="Especialidade"
                            show-default-option
                            text-field="nome"
                            v-model="model.especialidadeId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="auto">
                        <rkm-button
                            :label="false"
                            @click="$refs.Form.validate(search)"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="reset"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            no-margin-top
            title="Resultado"
        >
            <template v-slot:trailing>
                <rkm-button
                    :disabled="itens.length === 0"
                    @click="print"
                    color="info"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    :disabled="itens.length === 0"
                    @click="exportTo"
                    color="info"
                    small
                    title="Exportar"
                >
                    <rkm-icon icon="file-export" />
                </rkm-button>
            </template>

            <rkm-table
                v-for="(infraestrutura, i) in itens"
                :class="{ 'mt-2': i > 0 }"
                :fields="columns"
                :foot-clone="itens.length > 0"
                :items="infraestrutura.usuarios"
                :key="i"
                hide-filters
                hide-pagination
                no-footer-sorting
            >
                <template #thead-top>
                    <rkm-tr>
                        <rkm-th
                            :colspan="columns.length"
                            class="text-center"
                        >
                            Unidade: {{ infraestrutura.unidadeNomeFantasia }}<br>Local de atendimento: {{ infraestrutura.infraestruturaNome }}
                        </rkm-th>
                    </rkm-tr>

                    <rkm-tr>
                        <rkm-th></rkm-th>

                        <rkm-th
                            :colspan="columns.length - 2"
                            class="text-center"
                        >
                            Dia do mês
                        </rkm-th>

                        <rkm-th></rkm-th>
                    </rkm-tr>
                </template>

                <template #foot(usuarioNome)>
                    <span></span>
                </template>

                <template #foot(quantidade01)><span>{{ infraestrutura.quantidade01 }}</span></template>
                <template #foot(quantidade02)><span>{{ infraestrutura.quantidade02 }}</span></template>
                <template #foot(quantidade03)><span>{{ infraestrutura.quantidade03 }}</span></template>
                <template #foot(quantidade04)><span>{{ infraestrutura.quantidade04 }}</span></template>
                <template #foot(quantidade05)><span>{{ infraestrutura.quantidade05 }}</span></template>
                <template #foot(quantidade06)><span>{{ infraestrutura.quantidade06 }}</span></template>
                <template #foot(quantidade07)><span>{{ infraestrutura.quantidade07 }}</span></template>
                <template #foot(quantidade08)><span>{{ infraestrutura.quantidade08 }}</span></template>
                <template #foot(quantidade09)><span>{{ infraestrutura.quantidade09 }}</span></template>
                <template #foot(quantidade10)><span>{{ infraestrutura.quantidade10 }}</span></template>
                <template #foot(quantidade11)><span>{{ infraestrutura.quantidade11 }}</span></template>
                <template #foot(quantidade12)><span>{{ infraestrutura.quantidade12 }}</span></template>
                <template #foot(quantidade13)><span>{{ infraestrutura.quantidade13 }}</span></template>
                <template #foot(quantidade14)><span>{{ infraestrutura.quantidade14 }}</span></template>
                <template #foot(quantidade15)><span>{{ infraestrutura.quantidade15 }}</span></template>
                <template #foot(quantidade16)><span>{{ infraestrutura.quantidade16 }}</span></template>
                <template #foot(quantidade17)><span>{{ infraestrutura.quantidade17 }}</span></template>
                <template #foot(quantidade18)><span>{{ infraestrutura.quantidade18 }}</span></template>
                <template #foot(quantidade19)><span>{{ infraestrutura.quantidade19 }}</span></template>
                <template #foot(quantidade20)><span>{{ infraestrutura.quantidade20 }}</span></template>
                <template #foot(quantidade21)><span>{{ infraestrutura.quantidade21 }}</span></template>
                <template #foot(quantidade22)><span>{{ infraestrutura.quantidade22 }}</span></template>
                <template #foot(quantidade23)><span>{{ infraestrutura.quantidade23 }}</span></template>
                <template #foot(quantidade24)><span>{{ infraestrutura.quantidade24 }}</span></template>
                <template #foot(quantidade25)><span>{{ infraestrutura.quantidade25 }}</span></template>
                <template #foot(quantidade26)><span>{{ infraestrutura.quantidade26 }}</span></template>
                <template #foot(quantidade27)><span>{{ infraestrutura.quantidade27 }}</span></template>
                <template #foot(quantidade28)><span>{{ infraestrutura.quantidade28 }}</span></template>
                <template #foot(quantidade29)><span>{{ infraestrutura.quantidade29 }}</span></template>
                <template #foot(quantidade30)><span>{{ infraestrutura.quantidade30 }}</span></template>
                <template #foot(quantidade31)><span>{{ infraestrutura.quantidade31 }}</span></template>

                <template #foot(quantidade)>
                    <span>{{ infraestrutura.quantidade }}</span>
                </template>
            </rkm-table>

            <rkm-table
                v-if="itens.length > 0"
                class="mt-2"
                :fields="columnsTotalizadores"
                :items="[totalizadores]"
                hide-filters
                hide-pagination
            >
                <template #thead-top>
                    <rkm-tr>
                        <rkm-th
                            :colspan="columnsTotalizadores.length"
                            class="text-center"
                        >
                            Totalizadores
                        </rkm-th>
                    </rkm-tr>

                    <rkm-tr>
                        <rkm-th
                            :colspan="columnsTotalizadores.length - 1"
                            class="text-center"
                        >
                            Dia do mês
                        </rkm-th>

                        <rkm-th></rkm-th>
                    </rkm-tr>
                </template>
            </rkm-table>
        </rkm-area>
    </div>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'
import { repository, formats, error, data, object, stringCase, file } from '@/mixins'

export default {
    computed: {
        columns() {

            const columns = [
                { key: 'usuarioNome', label: 'Profissional', sortable: true },
            ]

            this.dias.forEach(dia => columns.push({ key: `quantidade${dia}`, label: dia, class: 'text-center' }))
            columns.push({ key: 'quantidade', label: 'Quantidade', class: 'col-min text-center' })

            return columns
        },
        columnsTotalizadores() {

            const columns = []

            this.dias.forEach(dia => columns.push({ key: `quantidade${dia}`, label: dia, class: 'text-center' }))
            columns.push({ key: 'quantidade', label: 'Quantidade', class: 'col-min text-center' })

            return columns
        },
        dias() {

            const dias = []
            const data = moment([this.model.periodo.ano, this.model.periodo.mes - 1])
            const mes = data.month()
            const ultimoDia = moment(data).endOf('month').date()

            while (data.month() === mes && data.date() <= ultimoDia) {

                dias.push(data.format("DD"))
                data.add(1, 'day')
            }

            return dias
        },
        validations() {

            return {
                ano: { required: true, min: 4, max: 4 },
                mes: { required: true },
                periodo: { required: true },
            }
        },
        disableUnidade() {

            return !this.isPeriodoSelecionado
        },
        disableInfraestrutura() {

            return !this.isPeriodoSelecionado
                || this.model.unidadeId === null
        },
        disableOcupacao() {

            return !this.isPeriodoSelecionado
        },
        disableEspecialidade() {

            return !this.isPeriodoSelecionado
                || this.model.ocupacaoId === null
        },
        isPeriodoSelecionado() {

            return this.model !== null
                && typeof this.model.periodo.ano === 'string' && this.model.periodo.ano.length === 4
                && this.model.periodo.mes !== null
        },
    },
    created() {

        this.repositories = {
            relatorioQuantitativoAtendimento: this.getConectaSusRepository('ambulatorio.relatorioQuantitativoAtendimento'),
            impressao: this.getConectaSusRepository('impressao.ambulatorio'),
            exportacao: this.getConectaSusRepository('exportacao.ambulatorio'),
        }

        this.load()
    },
    data() {

        return {
            loaded: false,
            additionals: null,
            form: null,
            model: null,
            initials: {
                form: null,
                model: null,
            },
            itens: [],
            totalizadores: null,
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.relatorioQuantitativoAtendimento.list()
                .then(({ data }) => {

                    this.additionals = data.additionals
                    this.form = data.form
                    this.model = data.model

                    this.initials.form = this.clone(data.form)
                    this.initials.model = this.clone(data.model)

                    this.addWatchers()

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        addWatchers() {

            this.$watch('model.periodo', {
                deep: true,
                handler(periodo) {

                    if (periodo.ano === null
                        || (typeof periodo.ano === 'string' && periodo.ano.length < 4)
                        || periodo.mes === null
                    ) {

                        this.resetAfterPeriodo()
                    }
                    else {

                        this.loadFrom('periodo')
                    }
                }
            })
        },
        loadFrom(field) {

            this.clearFrom(field)

            this.setLoading()

            this.repositories.relatorioQuantitativoAtendimento.list({ ...this.prepareData(), load_from: this.camelToSnake(field) })
                .then(({ data }) => {

                    if ('form' in data) {

                        Object.keys(data.form).forEach(key => this.$set(this.form, key, data.form[key]))
                    }

                    Object.keys(data.model).forEach(key => this.$set(this.model, key, data.model[key]))
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        clearFrom(field) {

            if (field == 'periodo') {

                return
            }

            field = `${field}Id`

            const fields = [
                'unidadeId',
                'infraestruturaId',
                'ocupacaoId',
                'especialidadeId',
            ]

            fields.slice(fields.indexOf(field) + 1, fields.length)
                .forEach(key => this.$set(this.model, key, null))
        },
        search() {

            this.setLoading()

            this.repositories.relatorioQuantitativoAtendimento.index(this.prepareData())
                .then(({ data }) => {

                    this.itens = data.infraestruturas
                    this.totalizadores = data.totalizadores
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        reset() {

            this.form = this.clone(this.initials.form)
            this.model = this.clone(this.initials.model)

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        resetAfterPeriodo() {

            this.form = this.clone(this.initials.form)

            const model = this.clone(this.initials.model)

            delete model.periodo

            Object.keys(model).forEach(key => this.$set(this.model, key, model[key]))
        },
        print() {

            this.setLoading()

            this.repositories.impressao.relatorioQuantitativoAtendimento(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        exportTo() {

            this.setLoading()

            this.repositories.exportacao.relatorioQuantitativoAtendimento(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        prepareDataWithColumns() {

            const data = this.prepareData()

            data.columns = this.columns.map(f => ({
                key: this.camelToSnake(f.key),
                label: f.label,
                class: f.class
            }))

            return data
        },
        prepareData() {

            const data = this.clone(this.model)

            return this.camelObjectKeysToSnakeRecursive(data)
        },
    },
    mixins: [repository, formats, error, data, object, stringCase, file],
    watch: {
        model: {
            deep: true,
            handler() {

                this.itens = []
                this.totalizadores = null
            }
        },
    }
}
</script>

<style scoped>
.dropdown >>> .auto-scroll {
    max-height: 400px;
    overflow-y: auto;
    width: 400px;
}
.totalizador {
    background: #f1f1f1;
    border: 1px solid #dee2e6;
    padding: 0.5rem;
    color: var(--gray-dark);
    font-weight: 600;
}
</style>